import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  branch,
  compose,
  lifecycle,
  withState,
  getContext,
  withHandlers,
  renderNothing, withProps,
} from 'recompose';
import moment from 'moment';

import { setFrontendFlags } from '../../../auth/actions';
import NavExplainer from '../../../sidebar/navigation/NavExplainer';

export const IS_BRAND_BARBERS_NEW = moment().isBefore(moment('2023-10-01', 'YYYY-MM-DD'), 'day');

const BarberNavExplainer = compose(
  branch(
    () => !IS_BRAND_BARBERS_NEW,
    renderNothing,
  ),
  connect(null, { setFrontendFlags }),
  withState('opened', 'setOpened', true),
  withHandlers({
    close: props => () => {
      props.setFrontendFlags({ brandBarbersOnboarded: true });
      props.setOpened(false);
    },
  }),
  getContext({
    toggleSidebar: PropTypes.func.isRequired,
  }),
  withProps(() => ({
    title: 'Barber Management',
    description: 'Manage your barbers at all locations in your brand.',
  })),
  lifecycle({
    componentDidMount() {
      this.props.toggleSidebar(true);
    },
  }),
  branch(
    props => !props.opened,
    renderNothing,
  ),
)(NavExplainer);

export default BarberNavExplainer;
